import { CompositeFilterPath } from '../types';

import getFilterNestedField from './getFilterNestedField';

/**
 * Разбить составной ключ пути на составляющие
 * @param path {string} Составной путь `IFilterGridItem`
 */
const splitCompositeFilterPath = (path: string): CompositeFilterPath => {
  const field = getFilterNestedField(path);

  if (!field) {
    const [resolvedPath, collectionId] = path.split('.');

    if (!collectionId) {
      return { path: resolvedPath };
    }

    // @deprecated
    return {
      path: resolvedPath,
      field: {
        key: 'collection_id',
        value: collectionId,
      },
    };
  }

  const [resolvedPath] = path.split('[');

  return {
    path: resolvedPath,
    field,
  };
};

export default splitCompositeFilterPath;
